import LevelDialog, { LevelDialogProps } from './LevelDialog';

export type { LevelDialogProps };
export default LevelDialog;
